import { User } from "~/common/Store/models/User";

interface Product {
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  price: {
    minimumAdvertisedPriceProperties: {
      type: string;
    };
    displayMinimumAdvertisedPrice: boolean;
  };
}

export default (product: Product, user: User): boolean => {
  const {
    price: { minimumAdvertisedPriceProperties, displayMinimumAdvertisedPrice },
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
  } = product;

  const hasMapStyle = !!minimumAdvertisedPriceProperties?.type?.trim();

  const regularUserQualifiedForMapPricing =
    user.registered &&
    !(user.hasWebPlus || user.platinum.enabled) &&
    showBelowMinimumAdvertisedPriceForLoggedInCustomers;

  const regularUserQualifiedForMapJPricing =
    regularUserQualifiedForMapPricing && user.amountSpentOneThousandOrMore;

  const regularUserQualifiedForMapYPricing =
    regularUserQualifiedForMapPricing && user.amountSpentFiveThousandOrMore;

  const platPlusUserQualifiedForMapPricing =
    (user.hasWebPlus || user.platinum.enabled) &&
    (showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers);

  switch (minimumAdvertisedPriceProperties.type?.trim()) {
    case "F":
      return !!(
        user.registered &&
        (user.hasWebPlus ||
          user.platinum.enabled ||
          Number(user.analyticsData.total_orders) >= 2)
      );
    case "J":
      return (
        regularUserQualifiedForMapJPricing || platPlusUserQualifiedForMapPricing
      );
    case "G":
    case "O":
      return !!user.registered;
    case "L":
      return (
        !!(user.registered && user.hasPurchaseHistory) &&
        (showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
          (showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers &&
            (user.hasWebPlus || (user.platinum && user.platinum.enabled))))
      );
    case "Y":
      return (
        regularUserQualifiedForMapYPricing || platPlusUserQualifiedForMapPricing
      );
    default:
      return (
        hasMapStyle &&
        displayMinimumAdvertisedPrice &&
        ((showBelowMinimumAdvertisedPriceForLoggedInCustomers &&
          user.registered) ||
          platPlusUserQualifiedForMapPricing)
      );
  }
};
